import { BrowserRouter, Route, Routes } from "react-router-dom";

import AdminDashboard from "./admin/AdminDashboard";
import AdminLogin from "./admin/AdminLogin";
import AdminManageVillas from "./admin/AdminManageVillas";
import AdminPayment from "./admin/AdminPayment";
import AdminTransactions from "./admin/AdminTransactions";
import OwnerAvailability from "./admin/OwnerAvailability";
import OwnerDashboard from "./admin/OwnerDashboard";
import Booking from "./pages/Booking";
import Landingpage from "./pages/Landingpage";
import Payment from "./pages/Payment";
import Success from "./pages/Success";
import VillaDetail from "./pages/VillaDetail";
import Villas from "./pages/Villas";

function App() {
  return (
    <BrowserRouter>

      <Routes>

        <Route path="/" element={<Landingpage />} />

        <Route path="/villas" element={<Villas />} />

        <Route path="/villas/:id" element={<VillaDetail />} />

        <Route path="/booking" element={<Booking/>} />
 
        <Route path="/payment" element={<Payment />} />

        <Route path="/success" element={<Success />} />

        <Route path="/admin/login" element={<AdminLogin/>}/>

        <Route path="/admin/dashboard" element={<AdminDashboard />} />

        <Route path="/admin/villas" element={<AdminManageVillas/>}/>

        <Route path="/admin/transactions" element={<AdminTransactions />} />

        <Route path="/admin/payment" element={<AdminPayment />} />

        <Route path="/owner/dashboard" element={<OwnerDashboard/>}/>

        <Route path="/owner/availability" element={<OwnerAvailability />} />

      </Routes>

    </BrowserRouter>
  );
}

export default App;